import { create } from 'zustand'
import { timeEntriesApi } from '@/api/endpoints'
import type { TimeEntry } from '@/api/types'

interface TimerState {
  running: TimeEntry | null
  loaded: boolean
  refresh: () => Promise<void>
  start: (projectId: string, description?: string) => Promise<void>
  stop: () => Promise<void>
}

export const useTimerStore = create<TimerState>((set) => ({
  running: null,
  loaded: false,
  refresh: async () => {
    const running = await timeEntriesApi.running()
    set({ running, loaded: true })
  },
  start: async (projectId, description) => {
    const running = await timeEntriesApi.start(projectId, description)
    set({ running })
  },
  stop: async () => {
    await timeEntriesApi.stop()
    set({ running: null })
  },
}))
